import React from "react";
import Show from "../../../../../utils/show.component";
import { popupMenuOptions } from "../../../parent/data/popupMenuOptions";

export const ReplaceCardPopupButton = ({
  selectCardOption,
  CardType
}) => {
  const onClick = () => {
    window.scrollTo(0, 0);
    if (CardType === "DHSA" ) {
      selectCardOption(popupMenuOptions.invalid.IneligibleReplaceCard);
    }
    else {
      selectCardOption(popupMenuOptions.valid.ReplaceCard);
    }
    
  };

  return (
    <Show condition={true}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={onClick}
          data-e2e-id={"replace-card"}
        >
          Replace Card
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/card/menu/popup-menu-buttons/replace-card-popup-button.component.js